<template>
  <div
    class="py-1 card-footer footer-date-at d-flex justify-content-between align-items-center"
  >
    <p class="text-muted">
      <small
        ><strong>{{ $t('common_words.created_on') }}</strong
        >: {{ getFormattedCreatedAt }}</small
      >
      <small v-if="validateIsset(updatedAt)">
        - <strong>{{ $t('common_words.last_update') }}</strong
        >: {{ getFormattedUpdatedAt }}</small
      >
    </p>
    <user-operation-info
      :createdUser="createdUser"
      :updatedUser="updatedUser"
    />
  </div>
</template>
<script>
import { isset } from 'src/util/Util.js';
import moment from 'moment';
import UserOperationInfo from 'src/components/UserOperationInfo.vue';

export default {
  name: 'footer-date-at',
  components: {
    UserOperationInfo,
  },
  props: {
    createdAt: {
      type: String,
      default: '',
    },
    updatedAt: {
      type: String,
      default: '',
    },
    createdUser: {
      type: String,
      default: null,
    },
    updatedUser: {
      type: String,
      default: null,
    },
  },
  computed: {
    getFormattedCreatedAt() {
      return moment(String(this.createdAt), 'YYYY-MM-DD HH:mm:ss').format(
        'YYYY-MM-DD hh:mm:ss'
      );
    },
    getFormattedUpdatedAt() {
      return moment(String(this.updatedAt), 'YYYY-MM-DD HH:mm:ss').format(
        'YYYY-MM-DD hh:mm:ss'
      );
    },
  },
  methods: {
    validateIsset(data) {
      return isset(data);
    },
  },
};
</script>
<style scoped>
.text-muted {
  color: #ffffff !important;
}

.footer-date-at {
  background-color: #006535 !important;
  border-top: 1px solid #f0f0f0;
  margin-top: 0px;
}

.footer-date-at p {
  font-size: 14.5px !important;
}
</style>
